import { BACKEND_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type {
  CreatedOnboardingLink,
  CreateSsoOrganizationBody,
  SsoOrganization,
  SsoOrganizationDetail,
  UpdateSsoOrganizationBody,
} from './types';

/** Retraced staff's native-SSO tools — backend `/api/admin/sso`. */

export async function fetchSsoOrganizations(): Promise<{
  data: SsoOrganization[];
}> {
  return apiFetch<{ data: SsoOrganization[] }>(
    '/admin/sso/organizations',
    { method: 'GET' },
    BACKEND_URL,
  );
}

export async function fetchSsoOrganization(
  id: string,
): Promise<{ data: SsoOrganizationDetail }> {
  return apiFetch<{ data: SsoOrganizationDetail }>(
    `/admin/sso/organizations/${id}`,
    { method: 'GET' },
    BACKEND_URL,
  );
}

export async function createSsoOrganization(
  body: CreateSsoOrganizationBody,
): Promise<{ data: SsoOrganization }> {
  return apiFetch<{ data: SsoOrganization }>(
    '/admin/sso/organizations',
    { method: 'POST', body: JSON.stringify(body) },
    BACKEND_URL,
  );
}

export async function updateSsoOrganization(
  id: string,
  body: UpdateSsoOrganizationBody,
): Promise<{ data: SsoOrganization }> {
  return apiFetch<{ data: SsoOrganization }>(
    `/admin/sso/organizations/${id}`,
    { method: 'PATCH', body: JSON.stringify(body) },
    BACKEND_URL,
  );
}

export async function deleteSsoOrganization(id: string): Promise<void> {
  await apiFetch<void>(
    `/admin/sso/organizations/${id}`,
    { method: 'DELETE' },
    BACKEND_URL,
  );
}

export async function createSsoOnboardingLink(
  organizationId: string,
): Promise<{ data: CreatedOnboardingLink }> {
  return apiFetch<{ data: CreatedOnboardingLink }>(
    `/admin/sso/organizations/${organizationId}/onboarding-links`,
    { method: 'POST' },
    BACKEND_URL,
  );
}

export async function revokeSsoOnboardingLink(id: string): Promise<void> {
  await apiFetch<void>(
    `/admin/sso/onboarding-links/${id}`,
    { method: 'DELETE' },
    BACKEND_URL,
  );
}

export async function removeSsoConnection(
  organizationId: string,
): Promise<void> {
  await apiFetch<void>(
    `/admin/sso/organizations/${organizationId}/connection`,
    { method: 'DELETE' },
    BACKEND_URL,
  );
}

export async function switchSsoOrganizationToNative(
  organizationId: string,
): Promise<void> {
  await apiFetch<void>(
    `/admin/sso/organizations/${organizationId}/switch-to-native`,
    { method: 'POST' },
    BACKEND_URL,
  );
}
